// ─────────────────────────────────────────────────────────────────────────────
// NodeMarker — one node on the map: a status-coloured dot, two pulsing rings
// while the node is online, and its id as a tag when selected.
//   Positioned with the percentages from projectNodes(), so it stays glued to
//   its dot at any zoom (the whole viewport scales as one).
//   `--c` drives every colour in the marker's CSS.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./NodeMap.module.css";

export default function NodeMarker({ node, xPct, yPct, color, selected, onSelect }) {
  return (
    <button
      type="button"
      className={`${styles.marker} ${selected ? styles.markerActive : ""}`}
      style={{ left: `${xPct}%`, top: `${yPct}%`, "--c": color }}
      onClick={() => onSelect?.(node)}
      title={`${node.node_id} · ${node.status}`}
    >
      {node.online && (
        <>
          <span className={styles.ring} />
          <span className={`${styles.ring} ${styles.ring2}`} />
        </>
      )}
      <span className={styles.dot} />
      {selected && <span className={styles.tag}>{node.node_id}</span>}
    </button>
  );
}
